t = require('views/internal/teacup-with-helpers')('popover_change_board_org')

module.exports = ->
  t.form ->
    t.label ->
      t.format 'organization'
    t.select '.js-org', ->
      t.optionSelected !t.mustacheVar('orgs'), { value: '' }, ->
        t.format 'none'
      t.mustacheBlock 'orgs', ->
        t.optionSelected t.mustacheVar('select'), { value: t.mustacheVar('id') }, ->
          t.text t.mustacheVar('displayName')
    t.mustacheBlock 'isPrivate', ->
      t.div '.check-div.js-check-div', ->
        t.label ->
          t.input '.js-make-org-visible', { type: 'checkbox', checked: 'checked' }
          t.format 'make-board-visible-to-organization'
    t.mustacheBlockInverted 'allowsSelfJoin', ->
      t.div '.check-div.js-check-div', ->
        t.label ->
          t.input '.js-make-org-joinable', { type: 'checkbox', checked: 'checked' }
          t.format 'allow-any-org-member-to-join-this-board'
    t.input '.js-submit.wide.primary', { type: 'submit', value: t.l('change') }

    t.a { href: '#', class: 'js-new-org right-of-button-link' }, ->
        t.format 'create-team'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_change_board_org.coffee